import script from "./SpreadsheetFeature.vue?vue&type=script&setup=true&lang=js"
export * from "./SpreadsheetFeature.vue?vue&type=script&setup=true&lang=js"

import "./SpreadsheetFeature.vue?vue&type=style&index=0&id=29343434&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29343434"]])

export default __exports__